<template>
<div>
  <v-container
    fluid
    class="pa-0 mr-2"
  >
    <v-row
      no-gutters
      justify="center"
      align="center"
    >
      <v-col
        cols="12"
      >
        <LocationAutocomplete
          @address="handleAddress"
          @coordinates="handleCoordinates"
          :isManualEditable="false"
        />
      </v-col>
      <v-col
        cols="12"
        class="text-right"
      >
        <v-btn
        @click="handleBack"
        depressed
        dark
        small
        color="wrld_red"
        >
          {{ $t('buttons.back') }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>

</div>
</template>

<script>
  import LocationAutocomplete from '@/components/organizations/locations/LocationAutocomplete'
  export default {
    name: 'QuotingManualAddress',
    components: {
      LocationAutocomplete
    },
    methods: {
      handleBack () {
        this.$emit('close')
      },
      handleAddress (address) {
        let addressString = ''
        Object.keys(address).forEach((key, index) => {
          if (address[key] != null) {
            addressString += `${address[key]} `
          }
        })
        this.$emit('address', addressString)
      },
      handleCoordinates (coordinates) {
        this.$emit('coordinates', coordinates)
      },
    }
  }
</script>

<style lang="scss" scoped>

</style>
